import Vue from "vue";
import vuetify from "../vuetify.js";
import depsloader from "../depsloader";
import Searchform from "../components/contact/Searchform.vue";

export default function() {
  const element = document.querySelector("#vue-searchform");

  if (element) {
    depsloader.load("vue-i18n").then((vueI18n) => {
      Vue.use(vueI18n.VueI18n);

      new Vue({
        el: element,

        components: {
          Searchform
        },

        computed: {
          term() {
            let term = null;
            if (element.dataset.term) {
              term = element.dataset.term;
            }

            return term;
          },
        },

        vuetify,
        i18n: new vueI18n.VueI18n(vueI18n.options),

        render: h => h(Searchform)
      })
    });
  }
}
